// services/axios8400.js

import axios from 'axios';

const axios8400 = axios.create({
  baseURL: 'https://accounttaskgenerator-22559651326.us-east1.run.app',
  headers: {
    'Content-Type': 'application/json',
  },
});
// const axios8400 = axios.create({
//   baseURL: 'http://localhost:8400', // Adjust to the correct base URL
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

export default axios8400;
